import { setItem } from '@/lib/storageUtil';
import { LocalStorageKeys } from '@authentication/constants';
import { refreshAccessToken } from '@authentication/services/authServices';

import Axios from 'axios';

const axiosClient = Axios.create();

// Add a request interceptor
axiosClient.interceptors.request.use(
  function (config) {
    const accessToken = localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN);
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Response interceptor for API calls
axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401) {
      originalRequest._retry = true;
      try {
        const { token: newAccessToken, refreshToken: newRefreshToken } =
          await refreshAccessToken();
        axiosClient.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
        setItem(LocalStorageKeys.ACCESS_TOKEN, newAccessToken);
        setItem(LocalStorageKeys.REFRESH_TOKEN, newRefreshToken);

        return await axiosClient(originalRequest);
      } catch (refreshError) {
        return await Promise.reject(refreshError);
      }
    }
    return await Promise.reject(error);
  },
);

export default axiosClient;
